import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'

const pageApi = {
  state: {

  },

  mutations: {
    getChannelLists(state, data) {
      data.url = API.commission.getChannelLists
      CommonUtils.GetRequest(data)
    },
    getCpsProductList(state, data) {
      data.url = API.commission.getCpsProductList
      CommonUtils.GetRequest(data)
    },
    getCommissionProList(state, data) {
      data.url = API.commission.getProductList
      CommonUtils.GetRequest(data)
    }
  }
}

export default pageApi



// WEBPACK FOOTER //
// ./src/store/modules/commission.js